/* istanbul ignore file */
import { boolean as codecBoolean, number as codecNumber, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PatchTenantDataParser = /* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ codecOptional(codecString)],
    ['abbreviatedName', /* #__PURE__ */ codecOptional(codecString), 'abbreviated_name'],
    ['orderCategory', /* #__PURE__ */ codecOptional(codecNumber), 'order_category'],
    ['contractStart', /* #__PURE__ */ codecOptional(parsers.date), 'contract_start'],
    ['isHidden', /* #__PURE__ */ codecOptional(codecBoolean), 'is_hidden'],
]);
export class PatchTenantData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchTenantDataParser.decode(input).map(res => new PatchTenantData(res));
    }
    static unsafeDecode(input) {
        return PatchTenantData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchTenantDataParser.encode(data);
    }
    static schema() {
        return PatchTenantDataParser.schema();
    }
}
